import React, { useContext } from 'react'
import { Alert } from '@mui/material'
import GuiExerciseEditor from '../../../topBar/GuiExerciseEditor'
import { SessionContext } from '../../../../context/SessionContext'
import { getGuiSessionConfig } from '../../../workspace/config/guiSessionConfig'

// Final step for GUI/web-dev types. Renders the existing GuiExerciseEditor unmodified -
// it already covers the assignment text, the html/css/js scaffold, the target
// render/image, and the check list, so a GUI exercise needs one authoring step rather
// than the separate testcases + stubs pair the code types use.
//
// guiConfig is derived the same way Home.jsx:172 derives it. GuiExerciseEditor returns
// null without both a session and a guiConfig, and both of its saves no-op on a falsy
// session id, which is why the wizard only reaches this step after the row exists.
//
// authoringOnly drops the editor's Monitor tab and Distribute/raw-data controls. That is
// not only noise in a creation flow - InstructorDashboardPanel's subtree consumes five
// contexts that have no Provider outside /session/:id, so reaching it from here would
// throw and blank the page.
const GuiExerciseStep = () => {
  const { session } = useContext(SessionContext)
  const guiConfig = session ? getGuiSessionConfig(session) : null

  return (
    <>
      <div className="cq-card__head">
        <div>
          <h2>Exercise &amp; checks</h2>
          <p>Author the scaffold students start from and the checks that grade them.</p>
        </div>
      </div>

      {!guiConfig && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          No GUI configuration matched this session type.
        </Alert>
      )}

      <Alert severity="info" sx={{ mb: 2 }}>
        Checks are JavaScript expressions evaluated against the rendered document — for
        example <code>Boolean(htmlDoc.querySelector(&apos;main&apos;))</code>. The AI
        assistant drafts the assignment and the html/css/js scaffold, but it does not write
        checks; add those yourself. Use <strong>Save</strong> to persist.
      </Alert>

      <div className="cq-embed">
        <GuiExerciseEditor key={session?.id} guiConfig={guiConfig} authoringOnly />
      </div>
    </>
  )
}

export default GuiExerciseStep
